import React from 'react';
import styled from 'styled-components';
import {Grid, Typography, useTheme} from '@material-ui/core';

const StyledGrid = styled(Grid).attrs(
    (props: any) => ({
      active: props.active,
    }))`
  border: 2px solid ${props => props.active ?
    props.theme.palette.primary.main :
    '#d3d3d3'};
  
  line-height: 2;
  text-align: center;
  border-radius: 4px;
  transition: background-color 250ms;
  padding: 5px 0;
  margin-right: 5px;
  
  flex-grow: 1;
  flex-basis: 0;
  justify-content: space-around;
  
  
  &:last-child {
    margin-right: 0;
  }
  
  &:hover {
    background-color: #ececec;
    cursor: pointer;
    transition: background-color 250ms;
  }
`;

const RateItem = ({active, value, onClick}: { active: boolean, value: number, onClick: any }) => {
  const theme = useTheme();

  return (
      <StyledGrid active={+active} theme={theme} item onClick={onClick}>
        <Typography variant={'body1'}>{value}</Typography>
      </StyledGrid>
  );
};

RateItem.defaultProps = {active: false};

export default RateItem;
